import { MobilePermissionPageKey } from '@/types/permission';
import type { RouteRecordRaw } from 'vue-router';
import ProductionInspectLayout from '../pages/production/inspect/layout.vue';

export const routes: RouteRecordRaw = {
  path: '/mobile',
  name: 'mobile',
  redirect: '/mobile/login',
  children: [
    {
      path: 'login',
      name: 'mobile-login',
      component: () => import('../pages/login/index.vue'),
    },
    {
      path: 'login-account',
      name: 'mobile-login-account',
      component: () => import('../pages/login/mobile-account-login.vue'),
    },
    {
      path: 'login-feishu',
      name: 'mobile-login-feishu',
      component: () => import('../pages/login/mobile-feishu-login.vue'),
    },
    {
      path: 'home',
      name: 'mobile-home',
      component: () => import('../pages/home/index.vue'),
    },
    {
      path: 'issue-form',
      name: 'issue-form',
      children: [
        {
          path: '',
          name: 'create',
          component: () =>
            import('../pages/issue/mobile-issue-form-create.vue'),
        },
        {
          path: ':issueKey',
          name: MobilePermissionPageKey.IssueFormRead,
          component: () => import('../pages/issue/mobile-issue-form-read.vue'),
        },
      ],
    },
    {
      path: 'production',
      name: 'mobile-production',
      children: [
        {
          path: 'inspect',
          name: 'mobile-production-inspect',
          component: ProductionInspectLayout,
          children: [
            {
              path: 'package',
              name: 'mobile-production-inspect-package',
              component: () =>
                import('../pages/production/inspect/package-inspect-order.vue'),
            },
            {
              path: 'inspect',
              name: 'mobile-production-inspect-inspect',
              component: () =>
                import('../pages/production/inspect/inspect-order.vue'),
            },
            {
              path: 'machine',
              name: 'mobile-production-inspect-machine',
              component: () =>
                import('../pages/production/inspect/machine-inspect-order.vue'),
            },
          ],
        },
        {
          path: 'repair',
          name: 'mobile-production-repair',
          component: () => import('../pages/production/repair.vue'),
        },
      ],
    },
    {
      path: 'produce-issue',
      name: 'mobile-produce-issue',
      children: [
        {
          path: '',
          name: 'list',
          component: () => import('../pages/produceIssue/index.vue'),
        },
      ],
    },
  ],
};
